import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleLogout } from "../../utilities/auth/authUtils";
import { getAdminGym } from "../../utilities/firestore/firestoreUtils"; // Import the getAdminGym function

// --- CSS --- //
import "../../styles/header-gym.css";

// --- ASSETS --- //
import logo from "../../assets/vert-cert-logo.png";
import MenuIcon from '@mui/icons-material/Menu';
import BadgeIcon from "@mui/icons-material/Badge";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from '@mui/icons-material/Home';

// --- COMPONENTS --- //
import Dropdown from "../Dropdown";

const Header_Gym = () => {
    // State to toggle dropdown visibility
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [gymName, setGymName] = useState("");
    const navigate = useNavigate();

    // Fetch the gym name on component mount
    useEffect(() => {
        const fetchGymName = async () => {
            try {
                const name = await getAdminGym();
                setGymName(name || "Unknown Gym User"); // Fallback if no name is returned
            } catch (error) {
                setGymName(""); // Error fallback
            }
        };

        fetchGymName();
    }, []);

    // Toggle dropdown handler
    const toggleDropdown = () => {
        setIsDropdownVisible((prev) => !prev);
    };

    // Updated dropdown menu items
    const dropdownItems = [
        { icon: <HomeIcon />, title: "HOME", link: "/" },
        { icon: <BadgeIcon />, title: "Employees", link: "/gym-employees" },
        { icon: <NewReleasesIcon />, title: "Certify", link: "/certify" },
        { icon: <LogoutIcon />, title: "Logout", onClick: () => handleLogout(navigate), style: { color: "var(--button-delete-bg)" } },
    ];

    return (
        <>
            {/* HEADER */}
            <div id="header-container">
                {/* LOGO */}
                <div id="logo-container">
                    <a href="/"><img src={logo} alt="Vert Cert Logo" /></a>
                </div>

                {/* ACCOUNT ICON */}
                <div id="account-dropdown-container">
                    <h2 className="dropdown-name">{gymName}</h2>
                    <span onClick={toggleDropdown} style={{ cursor: "pointer" }}>
                        <MenuIcon style={{ fontSize: 40, color: "var(--text-primary)" }} />
                    </span>
                </div>
            </div>

            {/* DROPDOWN MENU */}
            {isDropdownVisible && (
                <Dropdown
                    items={dropdownItems.map((item) => ({
                        ...item,
                        onClick: item.onClick
                            ? item.onClick
                            : () => navigate(item.link), // Default navigation handler
                    }))}
                />
            )}
        </>
    );
};

export default Header_Gym;